export default __webpack_public_path__ + "static/media/scdream4.83af67c2.woff2";